"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _helpers = require("@qwkin/helpers");
var _CheckButton = require("./CheckButton.styles");
var _theme = require("../utils/theme");
var _excluded = ["htmlFor", "theme", "className", "children", "checked", "onChange", "disabled"];
var CheckButton = function CheckButton(_ref) {
  var htmlFor = _ref.htmlFor,
    theme = _ref.theme,
    className = _ref.className,
    children = _ref.children,
    checked = _ref.checked,
    _onChange = _ref.onChange,
    disabled = _ref.disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: htmlFor
  }, /*#__PURE__*/_react["default"].createElement(_CheckButton.CheckboxContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_CheckButton.HiddenCheckbox, (0, _extends2["default"])({
    id: htmlFor,
    checked: checked,
    disabled: disabled,
    onChange: function onChange(e) {
      _onChange(!checked);
      e.stopPropagation();
    }
  }, props)), /*#__PURE__*/_react["default"].createElement(_CheckButton.StyledCheckbox, {
    checked: checked,
    theme: theme,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement(_CheckButton.CheckboxText, {
    checked: checked,
    theme: theme,
    disabled: disabled
  }, children)));
};
CheckButton.defaultProps = {
  checked: false,
  onChange: _helpers.identity,
  theme: _theme.defaultTheme,
  htmlFor: 'checkbox'
};
CheckButton.propTypes = {
  htmlFor: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  theme: _propTypes["default"].object
};
var _default = exports["default"] = CheckButton;